export default "__VITE_ASSET__Ch9y$Whn__"